import { render } from "./TxAudienceTab.vue?vue&type=template&id=4cb3e80d&scoped=true"
import script from "./TxAudienceTab.vue?vue&type=script&lang=js"
export * from "./TxAudienceTab.vue?vue&type=script&lang=js"

import "./TxAudienceTab.vue?vue&type=style&index=0&id=4cb3e80d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb3e80d"]])

export default __exports__